import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * DropdownItem - A wrapper that renders a standard HTML a or div with Bulma class names
 *
 * This component accepts the same props as Bloomer DropdownItem for easy migration
 */
const DropdownItem = ({ 
  className, 
  children, 
  style, 
  isActive, 
  href, 
  onClick,
  ...props 
}) => {
  // Build the class names based on props
  const getClassNames = () => {
    return classNames('dropdown-item', {
      'is-active': isActive,
      [className]: className,
    });
  };

  // If href is provided, render an anchor tag, otherwise render a div
  if (href) {
    return (
      <a 
        className={getClassNames()} 
        style={style} 
        href={href}
        onClick={onClick}
        {...props}
      >
        {children}
      </a>
    );
  }

  return (
    <div 
      className={getClassNames()} 
      style={style} 
      onClick={onClick}
      {...props}
    >
      {children}
    </div>
  );
};

DropdownItem.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
  isActive: PropTypes.bool,
  href: PropTypes.string,
  onClick: PropTypes.func,
};

DropdownItem.defaultProps = {
  className: '',
  style: {},
  children: null,
  isActive: false,
  href: null,
  onClick: null,
};

export default DropdownItem;
